import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { Input, SubmitButton, SubTab, SubInput ,
  RenderInputFields,

  } from "../Form/Form";
import { createSlug } from "../../util/fn";

const AddYear = (props) => {

  const modelId = window.location.href.split("/")[7];
  const brandId = window.location.href.split("/")[4];
  const { id } = props.match.params;

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = useForm();
  const history = useHistory();

  const { languages } = useSelector((state) => state.setting);
  const { response, request } = useRequest();

  useEffect(() => {
    document.title = "Add New Year - Easyspare";
  }, []);
  useEffect(() => {
    if (response) {
      toast.success("Year added successfully.");
      history.push(`/brands/${brandId}/models/year/${modelId}`);

    }
  }, [response]);

  const onSubmit = (data) => {
    const {year} = data

    

    request("POST", "brand-model/year", {
      year,
      id,
    });
  };


  const InputFields = [
    [
      {
        Component: Input,
        label: "Manufacturing Year",
        type: "text",
        name: "year",
        registerFields: {
          required: true,
        },
      },
     
     
     
     
    ],
  ];
  return (
    <div
      className={` content d-flex flex-column flex-column-fluid`}
      id="kt_content"
    >
      <Breadcrumb
        title="Add Year"
        links={[
          { to: "/", name: "Dashboard" },
          { to: `/brands/${brandId}/models/year/${modelId}`, name: "Back To Manufactiring Year" },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card card-custom">
            <div className="card-header">
              <h3 className="card-title">Add Year</h3>
            </div>

            <div className="card-body">
              <div className="row">
                <div className="col-xl-12">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="card card-custom gutter-b">
                      <div className="card-header card-header-tabs-line">
                        <div className="card-toolbar">
                          <ul
                            className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                            role="tablist"
                          >
                            {/* {languages.length > 0 &&
                              languages.map((lang, index) => (
                                <SubTab
                                  key={index}
                                  name={lang.name}
                                  index={index}
                                  image={lang?.image}
                                  tabName={`language_${index}`}
                                />
                              ))} */}
                          </ul>
                        </div>
                      </div>

                      <div className="card-body px-0">
                        <div className="tab-content px-10">
                        <RenderInputFields
                              InputFields={InputFields}
                              errors={errors}
                              register={register}
                            />
                        </div>
                      </div>
                    </div>
                    <div className="row"></div>
                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Submit"
                      pxClass="px-10"
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddYear;
